import { collectionItems } from "@/mocks/collections";
import SectionHeading from "./SectionHeading";

export default function CollectionsSection() {
  return (
    <section
      id="collections"
      className="section-anchor w-full bg-background-100 border-y border-background-200/70"
    >
      <div className="w-full px-4 md:px-8 py-14 md:py-24">
        <div className="max-w-7xl mx-auto">
          <SectionHeading
            eyebrow="内容构成"
            title="潘金莲电影合集包含哪些内容"
            desc="合集并非单一类型，而是由六个彼此不同的方向共同组成。每一类在叙事长度、取材来源与观看感受上都有区别，按方向浏览会更清晰。"
          />

          <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {collectionItems.map((item) => (
              <article
                key={item.id}
                className="group rounded-lg bg-background-50 border border-background-200/70 overflow-hidden flex flex-col"
              >
                <div className="w-full h-44 overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.alt}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="p-5 flex flex-col flex-1">
                  <div className="flex items-center gap-2.5">
                    <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-100 text-primary-700">
                      <i className={item.icon}></i>
                    </span>
                    <h3 className="font-heading text-lg font-semibold text-foreground-950">
                      {item.title}
                    </h3>
                  </div>
                  <p className="mt-3 text-sm leading-relaxed text-foreground-700 flex-1">
                    {item.summary}
                  </p>
                  <div className="mt-4 flex flex-wrap gap-2">
                    {item.points.map((p) => (
                      <span
                        key={p}
                        className="px-2.5 py-1 rounded-full text-xs bg-secondary-100 text-secondary-900"
                      >
                        {p}
                      </span>
                    ))}
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}